import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "LoginPanel" }
const _hoisted_2 = { class: "LoginPanel__form" }
const _hoisted_3 = { class: "LoginPanel__fail" }
const _hoisted_4 = { key: 0 }

import { ref, computed } from "vue";
import InnInput from "@/components/ds/input/Input.vue";
import InnButton from "@/components/ds/button/Button.vue";
import api from "@/api";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginPanel',
  props: {
    reset: {
        type: Boolean,
        required: false,
        default: false,
    },
},
  emits: ["success"],
  setup(__props, { emit: __emit }) {



const emit = __emit;

const loading = ref(false);

const submit = () => {
    loading.value = true;
    api.login(user.value)
        .then((response: { access_token: string }) => {
            failMessage.value = "";
            localStorage.token = response.access_token;
            emit("success");
        })
        .catch((error) => {
            failMessage.value = error.message;
        })
        .finally(() => {
            loading.value = false;
        });
};

const failMessage = ref("");

const user = ref({
    email: "",
    password: "",
});

const isDisabled = computed(() => {
    return (
        user.value.email.length === 0 ||
        user.value.password.length === 0 ||
        loading.value
    );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(InnInput, {
        placeholder: "Email",
        modelValue: user.value.email,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((user.value.email) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(InnInput, {
        type: "password",
        placeholder: "Password",
        modelValue: user.value.password,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((user.value.password) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(InnButton, {
        disabled: isDisabled.value,
        onClick: submit
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode("Login")
        ])),
        _: 1
      }, 8, ["disabled"]),
      _createElementVNode("div", _hoisted_3, [
        (failMessage.value.length)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(failMessage.value), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})